import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 1rem;
  right: -1rem;
  width: 18rem;
  height: 6.2rem;

  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 3px 4px #0000001a;
  border: 1px solid #e6e6e6;
  border-radius: 0.2rem;
  padding: 2rem 1.6rem;

  opacity: 0;
  pointer-events: none;
  transition: 180ms ease-in-out;
  transition-property: opacity, transform;

  > span {
    font-size: 1.6rem;
    color: #232323;
  }
`;
